import { render, staticRenderFns } from "./benefits-banner-item.vue?vue&type=template&id=c6980b24&scoped=true"
import script from "./benefits-banner-item.vue?vue&type=script&lang=js"
export * from "./benefits-banner-item.vue?vue&type=script&lang=js"
import style0 from "./benefits-banner-item.vue?vue&type=style&index=0&id=c6980b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6980b24",
  null
  
)

export default component.exports